<template>
  <ExercisesResultsHistoryList :list="exercises.history" />
</template>

<script>
import { mapState } from 'vuex'

import ExercisesResultsHistoryList from '@/components/Hub/Exercises/ExercisesResultsHistoryList.vue'

export default {
  name: 'HubExercisesResultsHistory',

  components: { ExercisesResultsHistoryList },

  computed: {
    ...mapState('exercises', ['exercises'])
  }
}
</script>
